var map = {
	"./cinema-11.png": 1389,
	"./cinema-12.png": 1390,
	"./cinema-13.png": 1391,
	"./cinema-14.png": 1392,
	"./cinema-15.png": 1393,
	"./cinema-16.png": 1394,
	"./cinema-17.png": 1395,
	"./cinema-18.png": 1396
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1388;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img ^\.\/cinema\-1.*\.png$
// module id = 1388
// module chunks = 173